export default "__VITE_PUBLIC_ASSET__d2a27103__"